<template>
  <div class="h-full overflow-auto bg-neutral-100">
    <div class="">
      <!-- content -->
      <div class="mx-auto mb-5 mt-5 max-w-5xl px-2">
        <div
          class="mx-0 mb-4 mt-4 bg-sky-50 shadow sm:mx-5 sm:my-5 sm:rounded-lg md:mx-8 md:my-8 xl:mx-auto xl:max-w-5xl"
        >
          <!-- Card Content goes here -->
          <div class="justify-between px-4 py-5 sm:p-10 lg:flex">
            <div>
              <h1 class="text-2xl font-extrabold">
                {{ appSettingsStore.applicationTitle }}
              </h1>
              <h2 class="mt-2 text-xl text-neutral-500 md:mt-1">
                <span class="font-semibold">Welcome, {{ userRef.firstName }}</span>
              </h2>
              <div class="prose prose-neutral mt-4 prose-li:marker:text-neutral-400 md:mt-5">
                <p>(Home Internal)</p>
              </div>
            </div>
            <div class="mt-6 items-start justify-start gap-5 space-y-5 sm:flex sm:space-y-0 lg:mt-0">
              <LogoutButton :as="BaseButton" variant="priority-hollow" class="w-full sm:w-auto" label="Sign Out" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { BaseButton } from "@modernary/mui/components/button";
import { MdrnFooter, useAppSettingsStore } from "@modernary/mui/components/common";
import { useUser } from "@modernary/mui/utils/authentication";
import { LogoutButton } from "@modernary/mui/utils/authentication/buttons";
import { routeNames } from "@/routes";
import { defineComponent } from "vue";

export default defineComponent({
  name: "HomeInternal",
  setup() {
    const { userRef } = useUser();
    const appSettingsStore = useAppSettingsStore();

    return {
      userRef,
      routeNames,
      BaseButton,
      appSettingsStore,
    };
  },
  components: {
    LogoutButton,
    MdrnFooter,
  },
});
</script>
